import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-SRVQZRQQ6T'); 
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
};

export const logEvent = ({ action, category = 'Quotation', label = '', value }) => {
  if (!action) {
    return;
  }

  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
